import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-expiration-input',
  templateUrl: './expiration-input.component.html',
  styleUrls: ['./_expiration-input.component.scss'],
})
export class ExpirationInputComponent implements OnInit, OnChanges {
  @Input() date: any;
  @Input() text: any;
  @Input() ExpirationId: any;
  @Input() ExpirationName: any;
  @Input() index: any;
  @Input() expiration_type: any;
  @Input() balsa_date: any;
  @Input() limitDays: any;

  @Output() dataEmitted: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteExpirationValue: EventEmitter<any> = new EventEmitter<any>();

  normalDate: string | Date = '';
  stringNormalDate: any = '';
  stringBalsaDate: any = '';
  identificador = '';
  id: any;
  type: any;
  debounceTimeout: any;
  balsaDate: string | Date = '';
  limit_days = 30;
  show_trash = false;
  es: any;

  constructor() {}

  ngOnInit() {
    if (this.id !== undefined) {
      this.show_trash = true;
    } else {
      this.show_trash = this.index !== 0;
    }

    this.es = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
      dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
      dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
      monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
      today: 'Hoy',
      clear: 'Borrar',
    };
  }

  ngOnChanges(changes: any) {
    if ('date' in changes) {
      this.normalDate = changes['date'].currentValue;
      this.stringNormalDate = this.normalDate;
      if (this.stringNormalDate !== null) {
        this.normalDate = new Date(this.stringNormalDate);
      }
    }
    if ('text' in changes) {
      this.identificador = changes['text'].currentValue;
    }
    if ('ExpirationId' in changes) {
      this.id = this.ExpirationId;
    }
    if ('ExpirationName' in changes) {
      this.type = this.ExpirationName;
    }
    if ('balsa_date' in changes) {
      this.balsaDate = changes['balsa_date'].currentValue;
      this.stringBalsaDate = this.balsa_date;
      if (this.stringBalsaDate !== null) {
        this.balsaDate = new Date(this.stringBalsaDate);
      }
    }
    if ('limitDays' in changes) {
      this.limit_days = this.limitDays;
    }
  }

  onSearchChange(): void {
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    this.debounceTimeout = setTimeout(() => {
      this.sendDataToParent();
    }, 300);
  }

  sendDataToParent() {
    const dataToSend = {
      id: this.id,
      expiration_type: this.type,
      date: this.dateToString(this.normalDate),
      text: this.identificador,
      zafa_expiration_date: this.dateToString(this.balsaDate),
    };
    this.dataEmitted.emit(dataToSend);
  }

  dateToString(date) {
    if (date === null) {
      return;
    }
    if (typeof date === 'string') {
      return;
    }

    const year = date.getFullYear();
    const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
    const day = (date.getDate() < 10 ? '0' : '') + date.getDate();

    return `${year}-${month}-${day}`;
  }

  isExpired(dateString: string, limitDays: number = 30): boolean {
    if (dateString === null) {
      return false;
    } // Si la fecha es nula, consideramos que no está expirada
    const now = new Date();
    const dateToCompare = new Date(dateString);

    const thirtyDaysFromNow = new Date(now);
    thirtyDaysFromNow.setDate(thirtyDaysFromNow.getDate() + limitDays);

    return dateToCompare <= thirtyDaysFromNow;
  }

  deleteExpiration() {
    this.deleteExpirationValue.emit(this.index);
  }
}



// WEBPACK FOOTER //
// ./src/app/expirations/expiration-item/expiration-input/expiration-input.component.ts